// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__16X4S","footer":"ChangeClinic_footer__1Gqdt"};